import React from 'react';
import { I18nSupport } from '@/utils/types';
import { Col, ComponentWithProps, Container, createArrayInRange, Row, Slider, useMedia } from '@visalex/core';

import cx from 'clsx';
import { useTranslation } from 'next-i18next';

import styles from './SeoFooter.module.scss';

const SeoFooter: ComponentWithProps<I18nSupport> = ({ i18nPrefix, className }) => {
  const { t } = useTranslation();
  const featureIds = createArrayInRange(0, 2);
  const isMobile = useMedia<boolean>(['(max-width: 768px)'], [true], false);

  return (
    <section className={cx(className, styles['seo-footer'])}>
      <Container className="full-width-mobile">
        <Row>
          <Col xs={12} xl={10} className="mx-auto">
            <Slider showArrows={!isMobile} showDots className="wide-slider">
              {featureIds.map((id) => (
                <div key={id} className={styles['seo-footer__slide']}>
                  <h3>{t(`${i18nPrefix}.seo-footer.${id}.title`)}</h3>
                  <p>{t(`${i18nPrefix}.seo-footer.${id}.description`)}</p>
                </div>
              ))}
            </Slider>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SeoFooter;
